import React, { useMemo } from "react";
import {
  SxProps,
  Theme,
  Typography as MuiTypography,
  TypographyProps as MuiTypographyProps,
  useTheme,
  Tooltip,
} from "@mui/material";

import { classDefinition, TypoSize, responsiveFontSize } from "./style";

export type TypographyProps = MuiTypographyProps & {
  size?: TypoSize;
  realTime?: boolean;
  reserveSpace?: boolean;
  component?: React.ElementType<any>;
  uppercase?: boolean;
  tooltip?: React.ReactNode;
};

const Typography = ({
  ref,
  ...props
}: TypographyProps & {
  ref?: React.Ref<HTMLSpanElement>;
}) => {
  const {
    size = "small",
    realTime = false,
    reserveSpace = false,
    fontSize,
    uppercase = false,
    sx,
    ...other
  } = props;

  const theme = useTheme();

  const styling = useMemo(
    (): SxProps<Theme> => [
      classDefinition(size, reserveSpace),
      fontSize === undefined
        ? responsiveFontSize(theme, size, reserveSpace)
        : { fontSize },
      { fontFamily: realTime ? "Realtime" : "Rubik" },
      { textTransform: uppercase ? "uppercase" : "none" },
      ...(Array.isArray(sx) ? sx : [sx]),
    ],
    [reserveSpace, size, realTime, uppercase, sx, fontSize]
  );

  return (
    <Tooltip arrow title={props.tooltip ?? ""}>
      <MuiTypography ref={ref} {...other} sx={styling} />
    </Tooltip>
  );
};

export default Typography;
